import classNames from 'classnames'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import styles from './Loader.css'

const Loader = ({ size = 32, className, spinning, message = 'LOADING' }) => {
  return (
    <Spin
      wrapperClassName={classNames(styles.loader, className)}
      indicator={(
        <LoadingOutlined
          style={{ fontSize: size }}
          spin
        />
      )}
      spinning={spinning}
      tip={(
        <div className={styles.message}>
          {message}
        </div>
      )}
    />
  )
}

export default Loader
